import axios from 'axios'
import Cookies from 'js-cookie'
import { API_KEY_LINX } from 'src/util/config'
import { SearchProductsResponse } from './dtos'
import { origin } from 'src/util/Linx'
import { ProductsSortingKey } from 'src/util/enums/products-sorting-key'

type ProductSearchQuery = {
  search: string
  filter?: string | string[]
  order: string | null
  page: number
}

type QueryParams = {
  category: string
  page: string
  resultsPerPage: string
  sortBy: string
  productFormat: string
  showOnlyAvailable: string
  deviceId?: string
}

export const searchProductsCategoryLinx = async ({
  search,
  filter,
  order,
  page,
}: ProductSearchQuery): Promise<SearchProductsResponse | undefined> => {
  const deviceId = Cookies.get('nav_id')
  const queryParams: QueryParams = {
    category: encodeURIComponent(search),
    page: String(page),
    resultsPerPage: '18',
    sortBy: order || ProductsSortingKey.Relevance,
    productFormat: 'complete',
    showOnlyAvailable: 'false',
    deviceId,
  }

  let filterString = ''

  if (Array.isArray(filter)) {
    filterString = filter.join('&filter=')
    filterString = filterString ? `&filter=${filterString}` : ''
  } else if (filter && !filter.startsWith('&filter=')) {
    filterString = `&filter=${filter}`
  }

  const completeUrl = new URLSearchParams(queryParams) + filterString
  try {
    const { data } = await axios.get<SearchProductsResponse>(
      `https://api.linximpulse.com/engage/search/v3/navigates?apiKey=${API_KEY_LINX}&${completeUrl}`,
      {
        headers: { origin: origin() },
      }
    )
    return data
  } catch (error) {
    return undefined
  }
}
